import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useAppSelector } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../store/reducers/user.reducer";
import axios from "axios";
import { addComments, addReply, dislikeVideo, getComments, getFeedbackStatus, getReplies, getVideoDetailsByID, likeVideo, reportVideo, supportVideo } from "../../services/APIServices/videos.api";
import { getChannelByID, getChannelVideos } from "../../services/APIServices/channel.api";
import { Avatar, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Skeleton, Slider, Stack, TextField, Typography, useTheme } from "@mui/material";
import { Send, MoreVert, Pause, PlayArrow, Share, ThumbDown, ThumbUp, VolumeOff, VolumeUp, Close, Info, Settings, Speed, Report, Check, KeyboardBackspace, ReportGmailerrorred, Block, FavoriteBorder } from "@mui/icons-material";
import CommentIcon from '@mui/icons-material/Comment';
import { getUserDetails, inscribeChannel } from "../../services/APIServices/user.api";
import { verifyAuth } from "../../services";
import { useAuth } from "../../context/AuthContext";
import { isUserChannel } from "../../utils";
import { PAGE_ROUTES } from "../../utils/constants";
import { RWebShare } from "react-web-share";
import CommentSection from "./CommentSection";
import moment from "moment";
import { colors } from "../../theme";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import { isMobile } from "react-device-detect";
import { toast } from "react-toastify";
import { blockChannel, blockVideo } from "../../services/APIServices/block.api";
import { getVideoURL, getQualityOptions } from "../../utils/videoQuality";
const baseURL = process.env.REACT_APP_SERVER_URL;

const Short = forwardRef(({ short, shortContainerRef, index, setCurrentVideoIndex, isActive, currentVideoIndex }, ref) => {
  const playPauseRef = useRef();
  const { t, i18n } = useTranslation();
  const videoRef = useRef();
  let videoID = short.videoID;
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(false);
  const [isLiked, setIsLiked] = useState(false);
  const token = localStorage.getItem('token');
  const [videoLoaded, setVideoLoaded] = useState(false);

  const [videoDetails, setVideoDetails] = useState(null);
  const [channel, setChannel] = useState(null);
  const [loading, setLoading] = useState(false);
  const [channelVideos, setChannelVideos] = useState(null);
  const user = useAppSelector((state) => getUser(state));
  const navigate = useNavigate();
  const [cancelToken, setCancelToken] = useState(null);
  const [liked, setLiked] = useState(false);
  const [disliked, setDisliked] = useState(false);
  const [reported, setReported] = useState(false);
  const [supported, setSupported] = useState(false);
  const { verifyAuth, setOnLoginSuccess } = useAuth();
  const [isSpamDialogOpen, setIsSpamDialogOpen] = useState(false);
  const [spamMessage, setSpamMessage] = useState("");
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isCommentOpen, setIsCommentOpen] = useState(false);
  const [usersDetails, setUsersDetails] = useState({});
  const [selectedQuality, setSelectedQuality] = useState("Auto");
  const [comments, setComments] = useState([]);
  const [replyInput, setReplyInput] = useState(null);
  const [commentInput, setCommentInput] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [replies, setReplies] = useState([]);
  const inputRef = useRef(null);
  const currentVideoIndexRef = useRef(0);
  const [isQualityMenuOpen, setIsQualityMenuOpen] = useState(false);
  const [isGlobalMuted, setIsGlobalMuted] = useState(localStorage.getItem("isGlobalMuted") || false);
  const theme = useTheme();

  const [isDescriptionMenuOpen, setIsDescriptionMenuOpen] = useState(false);
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false);
  const [selectedReason, setSelectedReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  useImperativeHandle(ref, () => ({
    getCurrentVideoIndex: () => currentVideoIndexRef.current,
    setCurrentVideoIndex: (index) => {
      currentVideoIndexRef.current = index;
    },
  }));

  const saveWatchedVideoId = (videoID) => {
    const watched = JSON.parse(localStorage.getItem("watchedVideos") || "[]");
    if (!watched.includes(videoID)) {
      watched.push(videoID);
      localStorage.setItem("watchedVideos", JSON.stringify(watched));
    }
  };

  // useEffect(() => {
  //   if (index === 0 && short.videoID && videoRef?.current) {
  //     videoRef?.current.play().catch((err) => console.error("Play error:", err));
  //     setIsPlaying(true);
  //     // setLoading(false);
  //   }

  //   const videoID = short.videoID;

  //   if (videoID && videoDetails?.videoID !== videoID) {
  //     const cancelTokenSource = axios.CancelToken.source();
  //     setCancelToken(cancelTokenSource);
  //     setLoading(true);
  //     getVideoDetailsByID(videoID, cancelTokenSource.token).then((res) => {
  //       setVideoDetails(res);
  //       getChannelByID(res?.channelID, user?.userID).then((res) => {
  //         setChannel(res);
  //       });
  //     });

  //     setLoading(false);
  //   }

  //   return () => {
  //     if (cancelToken) {
  //       cancelToken.cancel("Request cancelled");
  //     }
  //   };
  // }, [index, currentVideoIndexRef.current, short.videoID]);

  useEffect(() => {
    const videoID = short.videoID;

    if (index === 0 && videoID && videoRef?.current) {
      videoRef.current.play().catch((err) => console.error("Play error:", err));
      setIsPlaying(true);
    }

    let cancelTokenSource = axios.CancelToken.source();
    setCancelToken(cancelTokenSource);

    const fetchVideoDetails = async () => {
      if (videoID && videoDetails?.videoID !== videoID) {
        setLoading(true);
        try {
          const videoRes = await getVideoDetailsByID(videoID, cancelTokenSource.token);
          setVideoDetails(videoRes);

          const channelRes = await getChannelByID(videoRes?.channelID, user?.userID);
          setChannel(channelRes);
        } catch (err) {
          if (!axios.isCancel(err)) {
            console.error("Error fetching video/channel:", err);
          }
        } finally {
          setLoading(false);
        }

        if (!user?.userID) {
          saveWatchedVideoId(videoID);
        } else {
          localStorage.removeItem("watchedVideos");
        }
      }
    };

    fetchVideoDetails();

    return () => {
      if (cancelTokenSource) {
        cancelTokenSource.cancel("Request cancelled");
      }
    };
  }, [index, currentVideoIndexRef.current, short.videoID]);

  useEffect(() => {
    if (index === currentVideoIndexRef.current) {
      fetchVideoFeedBackDetails();
    }
  }, [index, currentVideoIndexRef.current, short.videoID]);

  const fetchVideoFeedBackDetails = async () => {
    if (user?.userID && short.videoID) {
      try {
        getFeedbackStatus(user.userID, short.videoID).then((feedbackStatus) => {
          setLiked(feedbackStatus.like || false);
          setDisliked(feedbackStatus.dislike || false);
          setReported(feedbackStatus.spam || false);
          setSupported(feedbackStatus.support || false);
        });
      } catch (error) {
        console.error("Error fetching video details or feedback status:", error);
      }
    }
  };

  const handleInscribe = () => {
    inscribeChannel(channel?.channelID, user?.userID).then(
      (res) => {
        let status = res?.message?.split(" ")?.[0];
        if (status && channel) {
          getChannelByID(videoDetails?.channelID, user?.userID).then(
            (res) => {
              setChannel(res);
            }
          );
        }
      }
    );
  };

  const handleSubscribeClick = () => {
    if (verifyAuth()) {
      handleInscribe();
    } else {
      setOnLoginSuccess(handleInscribe);
    }
  };

  const handleDislike = () => {
    dislikeVideo(user?.userID, videoDetails?.videoID).then(
      (res) => {
        fetchVideoFeedBackDetails();
        getVideoDetailsByID(videoDetails?.videoID).then(
          (res) => {
            setVideoDetails(res);
          }
        );
      }
    );
  };
  const handleDislikeClick = () => {
    if (verifyAuth()) {
      handleDislike();
    } else {
      setOnLoginSuccess(handleDislike);
    }
  };
  const handleSpam = () => {
    reportVideo(user?.userID, videoDetails?.videoID, spamMessage).then(
      (res) => {
        fetchVideoFeedBackDetails();
        getVideoDetailsByID(videoDetails?.videoID).then((res) => {
          setVideoDetails(res);
          setSpamMessage(""); // Clear the input
          setIsSpamDialogOpen(false); // Close the popup
        });
      }
    );
  };
  const handleSpamClick = () => {
    if (verifyAuth()) {
      setIsSpamDialogOpen(true);
    } else {
      setOnLoginSuccess(() => setIsSpamDialogOpen(true));
    }
  };

  const handleLike = () => {
    likeVideo(user?.userID, videoDetails?.videoID).then(
      (res) => {
        fetchVideoFeedBackDetails();
        getVideoDetailsByID(videoDetails?.videoID).then(
          (res) => {
            setVideoDetails(res);
          }
        );
      }
    );
  };
  const handleLikeClick = () => {
    if (verifyAuth()) {
      handleLike();
    } else {
      setOnLoginSuccess(handleLike);
    }
  };

  const handleSupport = () => {
    const watchTimeSeconds = Math.floor(currentTime);
    supportVideo(user?.userID, short.videoID, watchTimeSeconds).then(
      (res) => {
        fetchVideoFeedBackDetails();
        getVideoDetailsByID(short.videoID).then(
          (res) => {
            setVideoDetails(res);
          }
        );
      }
    );
  };

  const handleSupportClick = () => {
    if (verifyAuth()) {
      handleSupport();
    } else {
      setOnLoginSuccess(handleSupport);
    }
  };

  const handleChannelClick = () => {
    if (channel?.channelID) {
      navigate(`${PAGE_ROUTES.CHANNEL_PAGE}/profile/${channel?.channelID}`);
    }
  };

  const formatNumber = (value, suffix) => {
    if (value === undefined) return `0 ${suffix}`;
    if (value >= 1e9) return `${(value / 1e9).toFixed(1)}B ${suffix}`;
    if (value >= 1e6) return `${(value / 1e6).toFixed(1)}M ${suffix}`;
    if (value >= 1e3) return `${(value / 1e3).toFixed(1)}K ${suffix}`;
    return `${value} ${suffix}`;
  }

  useEffect(() => {
    // Interval to update current time and duration for short video
    const interval = setInterval(() => {
      if (videoRef.current) {
        const current = videoRef.current.currentTime; // For short video, use videoRef.currentTime
        const total = videoRef.current.duration; // For short video, use videoRef.duration
        setCurrentTime(current);
        setDuration(total);
      }
    }, 500); // Update every 500ms
    return () => clearInterval(interval); // Cleanup interval
  }, []);

  const handleQualityChange = (q) => {
    if (videoRef.current) {
      const current = videoRef.current.currentTime; // Get current time for short video
      setCurrentTime(current); // Set current time to state
      setSelectedQuality(q);
      setIsQualityMenuOpen(false);
      setTimeout(() => {
        if (videoRef.current) {
          videoRef.current.currentTime = current;
          videoRef?.current.play().catch((err) => console.error("Play error:", err));
        }
      }, 50); // Short delay before seeking
    }
  };

  useEffect(() => {
    if (videoID && index === currentVideoIndexRef.current) {
      getComments(videoID, 0, 10).then(async (res) => {
        if (!res) return;

        // ✅ Fetch user details for each comment and update response
        const updatedComments = await Promise.all(
          res.map(async (comment) => {
            let userRes = null;
            if (user?.userID) {
              userRes = await getUserDetails(comment.userID);
            }
            return {
              ...comment,
              profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
              formattedTime: new Date(comment.creationTime).toLocaleString(), // ✅ Format timestamp
            };
          })
        );

        setComments(updatedComments); // ✅ Set updated comments
      });
    }
  }, [index, currentVideoIndexRef.current, videoID]);

  const handleComment = () => {
    if (commentInput && videoID) {
      if (replyView) {
        addReply(commentInput, user?.userID, videoID, replyView?.commentID).then(() => {
          getReplies(replyView?.commentID, 0, 10).then(async (res) => {
            // ✅ Fetch user details for each reply and update the response
            const updatedReplies = await Promise.all(
              res.map(async (reply) => {
                let userRes = null;
                if (user?.userID) {
                  userRes = await getUserDetails(reply.userID);
                }

                return {
                  ...reply,
                  profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
                  formattedTime: new Date(reply.creationTime).toLocaleString(), // ✅ Format timestamp
                };
              })
            );
            setReplies(updatedReplies);
            // setReplies((prev) => ({ ...prev, [replyView?.commentID]: updatedReplies }));
          });
        });
      } else {
        addComments(commentInput, user?.userID, videoID).then(() => {
          getComments(videoID, 0, 10).then(async (res) => {
            // ✅ Fetch user details for each new comment and update response
            const updatedComments = await Promise.all(
              res.map(async (comment) => {
                let userRes = null;
                if (user?.userID) {
                  userRes = await getUserDetails(comment.userID);
                }
                return {
                  ...comment,
                  profilePic: userRes?.profilePic || "", // ✅ Add profilePic field
                  formattedTime: new Date(comment.creationTime).toLocaleString(), // ✅ Format timestamp
                };
              })
            );

            setComments(updatedComments); // ✅ Set updated comments
          });
        });
      }
      setCommentInput("");
      setReplyInput([]);
    }
  };

  const [replyView, setReplyView] = useState(null);

  const fetchReplies = async (commentID) => {
    try {
      const res = await getReplies(commentID);
      const updatedReplies = await Promise.all(
        res.map(async (reply) => {
          let userRes = null;
          if (user?.userID) {
            userRes = await getUserDetails(reply.userID);
          }
          return {
            ...reply,
            profilePic: userRes?.profilePic || "", // Add profilePic
            formattedTime: new Date(reply.creationTime).toLocaleString(), // Format time
          };
        })
      );
      setReplies(updatedReplies);
    } catch (error) {
      console.error("Error fetching replies:", error);
    }
  };

  // useEffect(() => {
  //   shortContainerRef.current.addEventListener("scroll", handleVideo);
  //   setIsPlaying(!videoRef.current.paused);
  //   setIsMuted(isGlobalMuted);
  //   window.addEventListener("blur", () => {
  //     console.log("Inside blur event");
  //     if (isActiveVideo(videoRef)) {
  //       console.log("Inside blur pause video");
  //       videoRef.current.pause();
  //       setIsPlaying(false);
  //     }
  //   });

  //   window.addEventListener("focus", () => {
  //     console.log("Inside focus event");
  //     if (isActiveVideo(videoRef)) {
  //       console.log("Inside focus event play");
  //       videoRef?.current.play().catch((err) => console.error("Play error:", err));
  //       setIsPlaying(true);
  //     }
  //   });
  // }, [shortContainerRef, isGlobalMuted]);

  // async function handleVideo() {
  //   if (!videoRef.current) {
  //     return;
  //   }

  //   const videoTop = videoRef.current.getBoundingClientRect().top;

  //   if (videoTop > 0 && videoTop <= 150) {
  //     try {
  //       console.log("Inside handle video videoTop play await");
  //       await videoRef?.current.play().catch((err) => console.error("Play error:", err));
  //       setIsPlaying(true);
  //       currentVideoIndexRef.current = index;
  //       videoRef.current.muted = isGlobalMuted;
  //       setIsMuted(isGlobalMuted);
  //     } catch (error) {
  //       console.error("Error playing video:", error);
  //       setIsPlaying(false);
  //       videoRef.current.pause();
  //       console.log("Inside handle video catch error");
  //     }
  //   } else {
  //     videoRef.current.currentTime = 0;
  //     videoRef.current.pause();
  //     console.log("Inside handle video !videoTop pause");
  //   }
  // }

  useEffect(() => {
    const container = shortContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleVideo);
    }

    const onBlur = () => {
      if (isActiveVideo(videoRef)) {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    };

    const onFocus = () => {
      if (isActiveVideo(videoRef)) {
        videoRef?.current.play().catch((err) => console.error("Play error:", err));
        setIsPlaying(true);
      }
    };

    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleVideo);
      }
      window.removeEventListener("blur", onBlur);
      window.removeEventListener("focus", onFocus);
    };
  }, []);

  const handleVideoDebounced = _.debounce(handleVideo, 200); // 200ms ka delay lagaya

  useEffect(() => {
    const container = shortContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleVideoDebounced);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleVideoDebounced);
      }
    };
  }, []);

  async function handleVideo() {

    if (!videoRef.current) {
      return;
    }

    setIsGlobalMuted(videoRef.current.muted);

    if (videoDetails !== null && user !== null && videoDetails.age >= 18 && user.age < 18) {
      return;
    }

    const videoTop = videoRef.current.getBoundingClientRect().top;

    if (videoTop > 0 && videoTop <= 150) {
      if (!videoRef.current.paused) return;

      try {
        await videoRef?.current.play().catch((err) => console.error("Play error:", err));
        setIsPlaying(true);
        currentVideoIndexRef.current = index;
      } catch (error) {
        setIsPlaying(false);
        videoRef.current.pause();
      }
    } else {
      if (!videoRef.current.paused) { // ✅ Already paused hai to dobara pause mat kar
        videoRef.current.currentTime = 0;
        videoRef.current.pause();
      }
    }
  }

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        setComments([...comments]);
      }, 100);
    }
  }, [isOpen]);

  const commentBoxRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (commentBoxRef.current && !commentBoxRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  const [isOptionsOpen, setIsOptionsOpen] = useState(false);
  const optionsRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (optionsRef.current && !optionsRef.current.contains(event.target)) {
        setIsOptionsOpen(false); // Close options popup
      }
    }

    if (isOptionsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen]);

  const speedOptions = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]; // Available speeds

  const [isSpeedMenuOpen, setIsSpeedMenuOpen] = useState(false);
  const [selectedSpeed, setSelectedSpeed] = useState(1); // Default Speed 1x

  const speedRef = useRef(null);
  const qualityMenuRef = useRef(null);

  // Close popup on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (speedRef.current && !speedRef.current.contains(event.target)) {
        setIsOptionsOpen(false);
        setIsSpeedMenuOpen(false);
      }
    }

    if (isOptionsOpen || isSpeedMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isSpeedMenuOpen]);

  // Close popup on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (qualityMenuRef.current && !qualityMenuRef.current.contains(event.target)) {
        setIsOptionsOpen(false);
        setIsQualityMenuOpen(false);
      }
    }

    if (isOptionsOpen || isQualityMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isQualityMenuOpen]);

  const descriptionMenuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (descriptionMenuRef.current && !descriptionMenuRef.current.contains(event.target)) {
        setIsOptionsOpen(false);
        setIsDescriptionMenuOpen(false);
      }
    }

    if (isOptionsOpen || isDescriptionMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOptionsOpen, isDescriptionMenuOpen]);


  const handleSpeedChange = (speed) => {
    setSelectedSpeed(speed);
    if (videoRef.current) {
      videoRef.current.playbackRate = speed; // Update video playback speed
    }
    setIsSpeedMenuOpen(false); // Close speed menu
  };

  useEffect(() => {
    document.querySelectorAll("video").forEach((vid) => {
      vid.muted = isGlobalMuted;
    });
  }, [isGlobalMuted]);

  const handleBlockChannel = async (channelID) => {
    if (!verifyAuth()) {
      setOnLoginSuccess(() => handleBlockChannel(channelID));
      return;
    }
    try {
      await blockChannel(channelID);
      toast.success("Channel blocked successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to block channel");
    }
  };

  const handleBlockVideo = async (videoID) => {
    if (!verifyAuth()) {
      setOnLoginSuccess(() => handleBlockVideo(videoID));
      return;
    }

    try {

      await blockVideo(videoID);

      toast.success("Video blocked successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to block video");
    }
  };

  const handleReport = (video) => {
    if (verifyAuth()) {
      setSelectedReason("");
      setCustomReason("");
      setIsReportDialogOpen(true);
    } else {
      setOnLoginSuccess(() => handleReport(video));
    }
  };

  const handleReportSubmit = (video) => {
    try {
      if (!selectedReason) {
        toast.warning("Please select a reason before submitting.");
        return;
      }

      const reason =
        selectedReason === "Other" && customReason.trim()
          ? `Other: ${customReason.trim()}`
          : selectedReason;

      const supportEmail = "contact@indeeclips.com";
      const subject = "Video Report";
      const body = [
        "Hello IndeeClips Team,",
        "",
        "I found an issue with the following video on the platform:",
        "",
        `Video Title: ${video?.title || "N/A"}`,
        `Channel Name: ${video?.channelName || "N/A"}`,
        `Reported Reason: ${reason}`,
        "",
        "Kindly look into this matter at the earliest and take the necessary action.",
        "",
        `Thanks & Regards,`,
        `${user?.email || "IndeeClips User"}`
      ].join("\n");

      const encodedSubject = encodeURIComponent(subject);
      const encodedBody = encodeURIComponent(body);

      const isMobile = /Android|iPhone|iPad|iPod/i.test(
        navigator.userAgent || ""
      );

      if (isMobile) {
        window.location.href = `mailto:${supportEmail}?subject=${encodedSubject}&body=${encodedBody}`;
      } else {
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=${encodedSubject}&body=${encodedBody}`;
        window.open(gmailUrl, "_blank", "noopener,noreferrer");
      }

      setIsReportDialogOpen(false);
      toast.success("Redirecting to email...");
    } catch (error) {
      console.error("Error while reporting video:", error);
      toast.error("Failed to open email. Please try again.");
    }
  };

  return (
    <div ref={ref} className={`reel`}>
      <div className={`reel-video ${isActive ? 'active' : ''}`}>
        <div className="video">
          {
            loading ? (
              isMobile ? (
                // 📱 Mobile: Full-screen grey background with "Loading..." text
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  width="100vw"
                  height="100vh"
                  bgcolor="#222"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  zIndex={9999}
                >
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{
                      bgcolor: "#444",
                      position: "absolute",
                      top: 0,
                      left: 0,
                      zIndex: -1,
                    }}
                    animation="wave"
                  />
                  <Typography variant="h6" sx={{ color: "#fff", zIndex: 1 }}>
                    Loading...
                  </Typography>
                </Box>
              ) : (
                // 💻 Desktop: Normal skeleton inside box
                <Box
                  width="100%"
                  height="100%"
                  bgcolor="#333"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{
                      bgcolor: "#444",
                      borderRadius: 2,
                    }}
                    animation="wave"
                  />
                </Box>
              )
            ) :
              videoDetails && user && videoDetails?.age >= 18 && user?.age < 18 ? (
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  transform="translate(-50%, -50%)"
                  width="100%"
                  height="100%"
                  padding="2px"
                  bgcolor="rgba(0, 0, 0, 0.8)"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  color="white"
                  textAlign="center"
                >
                  <Typography variant="body2" padding={2} >{t('ageRestrictedClips')}</Typography>
                </Box>
              ) : videoDetails && videoDetails?.deleted ? (
                <Box
                  position="absolute"
                  top={0}
                  left={0}
                  width="100%"
                  height="100%"
                  bgcolor="rgb(0, 0, 0)"
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  justifyContent="center"
                  color="white"
                  textAlign="center"
                  zIndex={10}
                >
                  <Typography variant="body2">
                    {t("clipDeletedMessage")}
                  </Typography>
                </Box>
              ) : (
                <>
                  {!videoLoaded && (
                    <Box
                      position="absolute"
                      top="50%"
                      left="50%"
                      sx={{ transform: "translate(-50%, -50%)" }}
                    >
                      <CircularProgress sx={{ color: "blue" }} />
                    </Box>
                  )}
                  <video
                    ref={videoRef}
                    onLoadedData={() => setVideoLoaded(true)}

                    onClick={function (e) {
                      if (!isPlaying) {
                        videoRef?.current.play().catch((err) => console.error("Play error:", err));
                        setIsPlaying(true);
                      } else {
                        videoRef?.current.pause();
                        setIsPlaying(false);
                      }
                    }}
                    playback={selectedSpeed}
                    playsInline
                    loop
                    src={getVideoURL(
                      baseURL,
                      short.videoID,
                      short.hlsProcessed || false,
                      selectedQuality
                    )}
                  ></video>
                </>
              )}

          <div className="controls">
            {isMobile ?
              <IconButton
                onClick={() => {
                  navigate(PAGE_ROUTES.HOME);
                  navigate(0);
                }}
              >
                <KeyboardBackspace />
              </IconButton> :
              <IconButton
                onClick={() => {
                  if (!isPlaying) {
                    videoRef?.current.play().catch((err) => console.error("Play error:", err));
                    setIsPlaying(true);
                  } else {
                    videoRef.current.pause();
                    setIsPlaying(false);
                  }
                }}
              >
                {isPlaying ? <Pause /> : <PlayArrow />}
              </IconButton>
            }

            <IconButton
              onClick={() => { setIsGlobalMuted((prevMuted) => !prevMuted); localStorage.setItem("isGlobalMuted", isGlobalMuted); }}
            >
              {isGlobalMuted ? <VolumeOff /> : <VolumeUp />}
            </IconButton>
          </div>
          <div
            ref={playPauseRef}
            onClick={() => {
              videoRef?.current.play().catch((err) => console.error("Play error:", err));
              setIsPlaying(true);
            }}
            className={`play-pause ${isPlaying ? "" : "show-play-pause"}`}
          >
            <PlayArrow />
          </div>
          <div className="reaction">
            {/* Support Button */}
            <div>
              <IconButton
                onClick={() => {
                  if (currentTime >= 60) {
                    handleSupportClick();
                  }
                }}
                disabled={
                  currentTime < 60 ||
                  isUserChannel(user?.channelList, channel?.channelID)
                }
                sx={{
                  color: supported ? "#027fff" : "white",
                  opacity: currentTime < 60 ? 0.5 : 1,
                  cursor: currentTime < 60 ? "not-allowed" : "pointer",
                  "&.Mui-disabled": {
                    color: "white",
                  },
                }}
              >
                <FavoriteBorder />
              </IconButton>
              <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                {t("support")}
              </Typography>
            </div>

            <div>
              <IconButton
                onClick={handleLikeClick}
                disabled={isUserChannel(user?.channelList, channel?.channelID)}
                sx={{
                  color: liked ? "#027fff" : "white",
                  "&.Mui-disabled": {
                    color: "white",
                  },
                }}
              >
                <ThumbUp />
              </IconButton>
              <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                {formatNumber(videoDetails?.likes, "")}
              </Typography>
            </div>

            {/* Dislike Button */}
            <div>
              <IconButton
                onClick={handleDislikeClick}
                disabled={isUserChannel(user?.channelList, channel?.channelID)}
                sx={{
                  color: disliked ? "#027fff" : "white",
                  "&.Mui-disabled": {
                    color: "white",
                  },
                }}
              >
                <ThumbDown />
              </IconButton>
              <Typography sx={{ fontSize: "10px", color: "#fff", textAlign: "center" }}>
                {formatNumber(videoDetails?.disLikes, "")}
              </Typography>
            </div>


            {/* Comment Button */}
            <div>
              <IconButton
                onClick={() => setIsOpen(!isOpen)}
                sx={{ color: "#fff" }}>
                <CommentIcon />
              </IconButton>
            </div>

            {/* Share Button */}
            <div style={{ zIndex: 13000 }}>
              <RWebShare
                data={{
                  text: videoDetails?.description,
                  url: `${window.location.origin}/watch/${videoDetails?.videoID}?type=clip`,
                  title: videoDetails?.title,
                }}
              >
                <IconButton
                  sx={{ color: "#fff" }}>
                  <Share />
                </IconButton>
              </RWebShare>
            </div>

            {/* More Options (Ellipsis) */}
            <div>
              <IconButton
                onClick={() => setIsOptionsOpen(true)} sx={{ color: "#fff" }}>
                <MoreVert />
              </IconButton>
            </div>
          </div>
          <div className="foot">
            <div className="user-info">
              <div
                onClick={handleChannelClick}
                style={{ cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}
              >

                <Avatar sx={{ width: 30, height: 30 }} src={channel?.profilePic} alt={channel?.name}>
                </Avatar>

                {/* Channel Name */}
                {channel?.name ? (
                  <span>{channel.name}</span>
                ) : (
                  <Skeleton width={100} height={20} />
                )}
              </div>
              {channel && (
                <button
                  onClick={isUserChannel(user?.channelList, channel?.channelID) ? null : handleSubscribeClick}
                  disabled={isUserChannel(user?.channelList, channel?.channelID)}
                  style={{
                    backgroundColor: isUserChannel(user?.channelList, channel?.channelID) ? "grey" : "#FF5722", // Orange for others, grey for own channel
                    cursor: isUserChannel(user?.channelList, channel?.channelID) ? "not-allowed" : "pointer",
                    color: "white",
                  }}
                >
                  {channel?.isSubscribed === true || channel?.isSubscribed === "SUBSCRIBED"
                    ? "Unsubscribe"
                    : "Subscribe"}
                </button>
              )}

            </div>
            <div className="title">
              {short?.title ? (
                short?.title
              ) : (
                <Skeleton width="60%" height={20} />
              )}
            </div>
          </div>


          <div className="progress-bar-container">
            <Slider
              value={(currentTime / duration) * 100 || 0}
              onChange={(_, value) => {
                if (videoRef.current) {
                  videoRef.current.currentTime = (value / 100) * duration;
                }
              }}
              sx={{
                position: "absolute",
                bottom: 0, // Stick to bottom
                left: 0, // Start from left
                width: "100%", // Full width
                color: "blue",
                height: 4,
                "& .MuiSlider-track": {
                  backgroundColor: "blue",
                },
                "& .MuiSlider-rail": {
                  backgroundColor: "white",
                  opacity: 1,
                },
                "& .MuiSlider-thumb": {
                  display: "none",
                },
              }}
            />
          </div>
          {isOpen && (
            <div ref={commentBoxRef}
              style={{
                position: "absolute",
                bottom: "0%",
                width: "100%",
                background: theme.palette.mode === "dark" ? "black" : "white",
                borderRadius: "10px",
                padding: "10px",
                height: "50vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {/* Sticky Header */}
              <div style={{ position: "sticky", top: 0, background: theme.palette.mode === "dark" ? "black" : "white", paddingBottom: "5px", zIndex: 10 }}>
                <Typography variant="h6" style={{ fontSize: "18px" }}>{t("comments")}</Typography>
              </div>

              <div style={{ flex: 1, overflowY: "auto" }}>
                {replyView ? (
                  <>
                    {/* Original Comment with Close Icon */}
                    <Stack direction="row" spacing={2} alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
                      <Avatar src={replyView.profilePic} alt={replyView.userName} />
                      <Stack>
                        <Typography variant="subtitle2" style={{ fontSize: "14px" }}>{replyView.userName}</Typography>
                        <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>{replyView.message}</Typography>
                      </Stack>
                      <IconButton onClick={() => setReplyView(null)}>
                        <Close />
                      </IconButton>
                    </Stack>
                    {replies.length === 0 ? (
                      <Typography variant="body2" marginTop={1} style={{ fontSize: "12px" }}>
                        {t("noReplies")}
                      </Typography>
                    ) : (
                      replies.map((reply) => (
                        <Stack key={reply.commentID} direction="row" spacing={2} alignItems="center" marginBottom={1} marginLeft={1}>
                          <Avatar src={reply.profilePic} alt={reply.userName} /> {/* Profile Picture */}
                          <Stack>
                            <Stack direction="row" spacing={1} alignItems="center">
                              <Typography variant="subtitle2" style={{ fontSize: "12px" }}>{reply.userName}</Typography>
                              <Typography variant="caption" color="textSecondary" style={{ fontSize: "10px" }}>
                                &nbsp;{`• ${moment(
                                  `${reply?.creationTime?.split("T")?.join(" ")} UTC`
                                ).fromNow()}`}
                              </Typography>
                            </Stack>
                            <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>
                              {reply.message}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="primary"
                              style={{ cursor: "pointer", fontSize: "12px" }}
                              onClick={() => { setReplyView(reply); fetchReplies(reply.commentID); }}
                            >
                              {t("replies", { count: reply.repiesCount })}
                            </Typography>
                          </Stack>
                        </Stack>
                      ))
                    )}

                  </>
                ) : (
                  <>
                    {/* Main Comments List */}
                    {comments.length === 0 ? (
                      <Typography variant="body2" style={{ fontSize: "12px" }}>{t("noComments")}</Typography>
                    ) : (
                      comments.map((cmt) => (
                        <Stack key={cmt.commentID} direction="column" spacing={1} marginBottom={1}>
                          <Stack direction="row" spacing={2} alignItems="center">
                            <Avatar src={cmt.profilePic} alt={cmt.userName} />
                            <Stack>
                              <Stack direction="row" spacing={1} alignItems="center">
                                <Typography variant="subtitle2" style={{ fontSize: "14px" }}>{cmt.userName}</Typography>
                                <Typography variant="caption" color="textSecondary" style={{ fontSize: "10px" }}>
                                  &nbsp;{`• ${moment(
                                    `${cmt?.creationTime?.split("T")?.join(" ")} UTC`
                                  ).fromNow()}`}
                                </Typography>
                              </Stack>
                              <Typography variant="body2" style={{ fontSize: "12px", color: "#555" }}>{cmt.message}</Typography>
                              <Typography
                                variant="caption"
                                color="primary"
                                style={{ cursor: "pointer", fontSize: "12px" }}
                                onClick={() => {
                                  setReplyView(cmt);
                                  fetchReplies(cmt.commentID); // ✅ Fetch Replies when clicking
                                }}
                              >
                                {t("replies", { count: cmt?.repiesCount })}
                              </Typography>
                            </Stack>
                          </Stack>
                        </Stack>
                      ))
                    )}
                  </>
                )}
              </div>

              {/* Sticky Input Box */}
              <div style={{ position: "sticky", bottom: 0, background: theme.palette.mode === "dark" ? "black" : "white", paddingTop: "5px", zIndex: 10 }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  {token ? (
                    <>
                      <TextField
                        inputRef={inputRef}
                        value={commentInput}
                        onChange={(e) => setCommentInput(e.target.value)}
                        placeholder={replyView ? `Reply to ${replyView.userName}` : "Add a comment"}
                        fullWidth
                        size="small"
                        style={{ fontSize: "12px" }}
                      />
                      <IconButton onClick={handleComment} color="primary">
                        <Send />
                      </IconButton>
                    </>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      {t("please")}{" "}
                      <span
                        onClick={() => verifyAuth()}
                        style={{ cursor: "pointer", color: colors.blueDark }}
                      >
                        {t("login")}
                      </span>{" "}
                      {t("toAddComment")}
                    </Typography>
                  )}
                </Stack>
              </div>
            </div>
          )}

          {/* More Options Popup */}
          {isOptionsOpen && (
            <div ref={optionsRef}
              style={{
                position: "absolute",
                bottom: "0%",
                width: "100%",
                background: theme.palette.mode === "dark" ? "black" : "white",
                borderRadius: "10px",
                padding: "10px",
                maxHeight: "50vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0px -2px 10px rgba(0,0,0,0.1)"
              }}>

              {/* Header with Close Icon */}
              <Stack direction="row" justifyContent="space-between" alignItems="center" paddingBottom={1} borderBottom="1px solid #ddd">
                <Typography variant="h6" style={{ fontSize: "16px" }}>{t('options')}</Typography>
                <IconButton onClick={() => setIsOptionsOpen(false)}>
                  <Close />
                </IconButton>
              </Stack>

              {/* Option Items */}
              <Stack spacing={2} marginTop={2}>
                <Stack direction="row" alignItems="center" spacing={2} onClick={() => setIsSpeedMenuOpen(true)} style={{ cursor: "pointer" }}>
                  <Speed sx={{ color: "#555" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>{t("playbackSpeed")}</Typography>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={2} onClick={() => { setIsOptionsOpen(false); setIsQualityMenuOpen(true); }} style={{ cursor: "pointer" }}>
                  <Settings sx={{ color: "#555" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>{t("quality")}</Typography>
                </Stack>

                <Stack direction="row" alignItems="center" spacing={2} onClick={() => setIsDescriptionMenuOpen(true)} style={{ cursor: "pointer" }}>
                  <Info sx={{ color: "#555" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>{t("description")}</Typography>
                </Stack>

                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{
                    cursor: isUserChannel(user?.channelList, channel?.channelID) ? 'not-allowed' : 'pointer',
                    color: isUserChannel(user?.channelList, channel?.channelID) ? 'grey' : reported ? 'blue' : 'default',
                  }}
                  onClick={isUserChannel(user?.channelList, channel?.channelID) ? null : handleSpamClick}
                >
                  <Report sx={{ color: isUserChannel(user?.channelList, channel?.channelID) ? 'grey' : reported ? 'blue' : 'default', }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>{t("spam")}</Typography>
                </Stack>

                {/* Block Video */}
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{ cursor: "pointer", color: "red" }}
                  onClick={() => handleBlockVideo(videoDetails?.videoID)}
                >
                  <Block sx={{ color: "red" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>
                    {t("videoCard.blockVideo")}
                  </Typography>
                </Stack>

                {/* Block Channel */}
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{
                    cursor: "pointer",
                    color: isUserChannel(user?.channelList, channel?.channelID)
                      ? "grey"
                      : "red",
                  }}
                  onClick={() =>
                    isUserChannel(user?.channelList, channel?.channelID)
                      ? null
                      : handleBlockChannel(channel?.channelID)
                  }
                >
                  <Block sx={{ color: isUserChannel(user?.channelList, channel?.channelID) ? "grey" : "red" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>
                    {t("videoCard.blockChannel")}
                  </Typography>
                </Stack>

                {/* Report */}
                <Stack
                  direction="row"
                  alignItems="center"
                  spacing={2}
                  sx={{ cursor: "pointer", color: "blue" }}
                  onClick={() => setIsReportDialogOpen(true)}
                >
                  <ReportGmailerrorred sx={{ color: "#1976d2" }} />
                  <Typography variant="body1" style={{ fontSize: "14px" }}>
                    {t("videoCard.report")}
                  </Typography>
                </Stack>
              </Stack>
            </div>
          )}

          {/* Playback Speed Popup */}
          {isSpeedMenuOpen && (
            <div ref={speedRef}
              style={{
                position: "absolute",
                bottom: "0%",
                width: "100%",
                background: theme.palette.mode === "dark" ? "black" : "white",
                borderRadius: "10px",
                padding: "10px",
                maxHeight: "50vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0px -2px 10px rgba(0,0,0,0.1)"
              }}>

              {/* Header with Back & Close Icon */}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom={1}
                borderBottom="1px solid #ddd"
                sx={{
                  position: "sticky",
                  top: "-10px",
                  background: theme.palette.mode === "dark" ? "black" : "white",
                  zIndex: 10
                }}
              >
                <Typography variant="h6" style={{ fontSize: "16px" }}>{t("playbackSpeed")}</Typography>
                <IconButton onClick={() => setIsSpeedMenuOpen(false)}>
                  <Close />
                </IconButton>
              </Stack>


              {/* Speed Options */}
              <Stack spacing={2} marginTop={2}>
                {speedOptions.map((speed) => (
                  <Stack
                    key={speed}
                    direction="row"
                    alignItems="center"
                    spacing={2}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => handleSpeedChange(speed)}
                  >
                    {selectedSpeed === speed && <Check sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }} />}
                    <Typography variant="body1" style={{ fontSize: "14px", fontWeight: selectedSpeed === speed ? "bold" : "normal" }}>
                      {speed}x {speed === 1 ? "(normal)" : ""}
                    </Typography>
                  </Stack>
                ))}
              </Stack>
            </div>
          )}

          {/* Quality Menu */}
          {isQualityMenuOpen && (
            <div ref={qualityMenuRef}
              style={{
                position: "absolute",
                bottom: "0%",
                width: "100%",
                background: theme.palette.mode === "dark" ? "black" : "white",
                borderRadius: "10px",
                padding: "10px",
                maxHeight: "50vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {/* Sticky Header */}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom={1}
                borderBottom="1px solid #ddd"
                sx={{
                  position: "sticky",
                  top: 0,
                  background: theme.palette.mode === "dark" ? "black" : "white",
                  zIndex: 10
                }}
              >
                <Typography variant="h6" style={{ fontSize: "16px" }}>{t("quality")}</Typography>
                <IconButton onClick={() => setIsQualityMenuOpen(false)}>
                  <Close />
                </IconButton>
              </Stack>

              {/* Quality Options */}
              {getQualityOptions().map((quality) => (
                <Stack
                  key={quality}
                  direction="row"
                  alignItems="center"
                  spacing={1}
                  padding="10px"
                  onClick={() => handleQualityChange(quality)}
                  sx={{
                    cursor: "pointer",
                    "&:hover": { backgroundColor: theme.palette.mode === "dark" ? "black" : "white", }
                  }}
                >
                  {/* Check Icon for Selected Quality */}
                  {selectedQuality === quality && <Check sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }} />}

                  {/* Quality Text */}
                  <Typography
                    variant="body1"
                    style={{ fontSize: "14px", fontWeight: selectedQuality === quality ? "bold" : "normal" }}
                  >
                    {quality}
                  </Typography>
                </Stack>
              ))}
            </div>
          )}

          {/* Description Menu */}
          {isDescriptionMenuOpen && (
            <div ref={descriptionMenuRef}
              style={{
                position: "absolute",
                bottom: "0%",
                width: "100%",
                background: theme.palette.mode === "dark" ? "black" : "white",
                borderRadius: "10px",
                padding: "10px",
                height: "50vh",
                overflowY: "auto",
                display: "flex",
                flexDirection: "column"
              }}
            >
              {/* Sticky Header */}
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                paddingBottom={1}
                borderBottom="1px solid #ddd"
                sx={{
                  position: "sticky",
                  top: 0,
                  background: theme.palette.mode === "dark" ? "black" : "white",
                  zIndex: 10
                }}
              >
                <Typography variant="h6" style={{ fontSize: "16px" }}>{t("description")}</Typography>
                <IconButton onClick={() => setIsDescriptionMenuOpen(false)}>
                  <Close />
                </IconButton>
              </Stack>

              {/* Description Content */}
              <Typography
                variant="body1"
                style={{ fontSize: "14px", padding: "10px", whiteSpace: "pre-wrap" }}
              >
                {videoDetails.description}
              </Typography>
            </div>
          )}


        </div>

      </div>

      {/* Report Dialog */}
      <Dialog open={isReportDialogOpen} onClose={() => setIsReportDialogOpen(false)}>
        <DialogTitle>{t("reportDialog.title")}</DialogTitle>
        <DialogContent>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {t("reportDialog.description")}
          </Typography>

          <TextField
            select
            fullWidth
            label={t("reportDialog.selectReasonLabel")}
            value={selectedReason}
            onChange={(e) => setSelectedReason(e.target.value)}
            sx={{ mb: selectedReason === "Other" ? 2 : 0 }}
          >
            {(t("reportDialog.reasons", { returnObjects: true })).map((reason, idx) => (
              <MenuItem key={idx} value={reason}>
                {reason}
              </MenuItem>
            ))}
          </TextField>

          {selectedReason === "Other" && (
            <TextField
              fullWidth
              label={t("reportDialog.enterReasonLabel")}
              multiline
              rows={3}
              value={customReason}
              onChange={(e) => setCustomReason(e.target.value)}
            />
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setIsReportDialogOpen(false)}>
            {t("reportDialog.cancel")}
          </Button>
          <Button
            variant="contained"
            onClick={() => handleReportSubmit(videoDetails)}
            disabled={
              !selectedReason ||
              (selectedReason === "Other" && !customReason.trim())
            }
          >
            {t("reportDialog.submit")}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={isSpamDialogOpen} onClose={() => setIsSpamDialogOpen(false)}>
        <DialogTitle>{reported ? t('removeSpam') : t('reportSpam')}</DialogTitle>
        <DialogContent>
          {reported ? (
            <Typography>{t('removeReportConfirmation')}</Typography>
          ) : (
            <TextField
              label={t('enterReason')}
              fullWidth
              multiline
              rows={4}
              value={spamMessage}
              onChange={(e) => setSpamMessage(e.target.value)}
            />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsSpamDialogOpen(false)}>{t('cancel')}</Button>
          <Button
            onClick={handleSpam}
            color="primary"
            disabled={!reported && !spamMessage.trim()} // Disable if no message when reporting
          >
            {reported ? t('remove') : t('submit')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
});

function isActiveVideo(videoRef) {
  if (!videoRef?.current) {
    return false; // Safeguard: Return false if the ref is not yet attached
  }
  const videoTop = videoRef.current.getBoundingClientRect().top;
  return videoTop > 0 && videoTop <= 150;
}

export default Short;
